import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SnackbarKey, SnackbarProvider, SnackbarProviderProps } from 'notistack';
import React, { FC, useRef }                                     from 'react';

const MAX_SNACK = 3;

export const NotistackProvider: FC<SnackbarProviderProps> = (props) => {
  const notistackRef = useRef<SnackbarProvider>(null);
  const portal = document.querySelector('body') as HTMLElement;

  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={MAX_SNACK}
      domRoot={portal}
      anchorOrigin={{
        vertical   : 'top',
        horizontal : 'right',
      }}
      action={(key) => (
        <IconButton
          size="small"
          onClick={onClickDismiss(key)}
        >
          <CloseIcon htmlColor="#ffffff" />
        </IconButton>
      )}
      {...props}
    />
  );
};
